export default "__VITE_ASSET__BdoB5ZbE__"